module.exports = __webpack_public_path__ + "img/vertical-bottom-right.231fc8ac.png";